import React, { FC, RefObject, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { TextField } from '@cld/text-field';
import { messages } from '../../../../../../i18n';
import { useOptions } from '../../../../../../selectors';
import { useHandleParamChange } from '../hooks/useHandleParamChange';

export interface LabelInputProps {
  inputRef?: RefObject<HTMLInputElement>,
}

const inputProps = {
  'data-test': 'custom-preset-label-textfield',
};

export const LabelInput: FC<LabelInputProps> = ({ inputRef }) => {
  const { formatMessage } = useIntl();
  const { label } = useOptions().customPreset.params;

  const handleParamChange = useHandleParamChange();

  const handleChange = useCallback((newLabel: string) => {
    handleParamChange('label', newLabel);
  }, [handleParamChange]);

  return (
    <TextField
      size="xs"
      type="text"
      placeholder={formatMessage(messages['section.resizeAndCrop.presets.customPreset.labelPlaceholder'])}
      value={label}
      onChange={handleChange}
      inputRef={inputRef}
      inputProps={inputProps}
    />
  );
};
